import React from 'react'

function ProductOffer() {
  return (
    <div className="flex flex-col justify-start items-start gap-2 py-4 pt-6 border-b-[1px] font-primaryFont discount-container">
          <div className="flex justify-self-start items-start gap-4 discount-card">
            <div>
              <img
                src="//www.snitch.co.in/cdn/shop/files/offer_icon-1_20x.png?v=1615371278/"
                alt=""
              />
            </div>
            <div>
              <p className="text-[12px]">
                Get this for <b className="">Rs. 899</b>
                <br />
                Buy 2 &amp; Get Flat 10% Off! Code: <strong>BUY2</strong>
              </p>
            </div>
          </div>
          <div className="flex justify-self-start items-start gap-4 discount-card">
            <div>
              <img
                src="//www.snitch.co.in/cdn/shop/files/offer_icon-1_20x.png?v=1615371278/"
                alt=""
              />
            </div>
            <div>
              <p className="text-[12px]">
                Get this for <b className="">Rs. 799</b>
                <br />
                Buy 5 &amp; Get Flat 20% Off! Code:
                <strong> BUY5</strong>
              </p>
            </div>
          </div>
          <div className="flex justify-self-start items-start gap-4 discount-card">
            <div>
              <img
                src="//www.snitch.co.in/cdn/shop/files/offer_icon-1_20x.png?v=1615371278/"
                alt=""
              />
            </div>
            <div>
              <p className="text-[12px]">
                Get this for <b className="">Rs. 849</b>
                <br />
                Flat 15% Off on minimum purchase of 2699/- <br />
                Code: <strong> FLAT15</strong>
              </p>
            </div>
          </div>
          <div className="flex justify-self-start items-start gap-4 discount-card">
            <div>
              <img
                src="//www.snitch.co.in/cdn/shop/files/offer_icon-1_20x.png?v=1615371278/"
                alt=""
              />
            </div>
            <div>
              <p className="text-[12px]">
                Get this for <b className="">Rs. 799</b>
                <br />
                Flat 20% Off on minimum purchase of 3999/- <br />
                Code: <strong> FLAT20</strong>
              </p>
            </div>
          </div>
        </div>
  )
}

export default ProductOffer